import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MetadataOrderType } from '../.././../../models/enums';

@Injectable({
  providedIn: 'root'
})
export class HardDriveMetadataServiceService {
  constructor(private httpClient: HttpClient) { }

  public async downloadHardDriveMetadata(orderNumber: number, shipmentNumber: number, orderType: (MetadataOrderType | null)) {
    const url = `api/HardDriveMetadata/${orderNumber}/${shipmentNumber}/${orderType}`;

    const response = await this.httpClient.get(url, { responseType: 'blob', observe: 'response' }).toPromise();

    const fileName = this.getFileNameFromHttpResponse(response.headers) || 'Metadata';

    const downloadUrl = URL.createObjectURL(response.body);
    const anchor = document.createElement('a');

    anchor.href = downloadUrl;
    anchor.download = fileName;
    anchor.click();

    URL.revokeObjectURL(downloadUrl);
    anchor.remove();
  }

  private getFileNameFromHttpResponse(headers: HttpHeaders): string | null {
    const contentDisposition = headers.get('Content-Disposition');
    if (contentDisposition !== null) {
      const result = contentDisposition.split(';')[1].trim().split('=')[1];
      return result.replace(/"/g, '');
    }

    return null;
  }
}
